/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from 'react';
import { Table } from 'reactstrap';
import 'wever-maps/src/assets/style.scss';

import '@/assets/scss/components/tab-sheet-action.scss';
import ResourceList from '@/components/resources/list';
import View from '@/components/view';
import Context from '@/services/context';

const GeoPoint = ({ match }) => {
  const { locale } = useContext(Context);

  return (
    <View>
      <ResourceList
        resource="GeometryPoint"
        deleteMultiple
        body={({ collection, renderColumn, renderItemActions, renderSelect }) => (
          <Table responsive hover>
            <thead className="thead-light">
              <tr>
                {renderColumn(renderSelect('*'), false)}
                {renderColumn('id')}
                {renderColumn('name')}
                {renderColumn('alias')}
                {renderColumn('description')}
                {renderColumn('group')}
                {renderColumn('type')}
                {renderColumn()}
              </tr>
            </thead>
            <tbody>
              {collection.map((item) => (
                <tr key={item.id}>
                  <td>{renderSelect(item.id)}</td>
                  <td>{item.id}</td>
                  <td>{item.name[locale]}</td>
                  <td>{item.alias}</td>
                  <td>{item.description}</td>
                  <td>{item.group}</td>
                  <td>{item.type}</td>
                  <td>{renderItemActions(item, null, true)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      />
    </View>
  );
};
export default GeoPoint;
